'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value && value.length >= 0 && Object.prototype.toString.call(value) === '[object Array]';
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-nprogress/lib/isArray.js
// module id = 1093
// module chunks = 2